import React from 'react';
import { IContentWithSidebar } from './interfaces';
import { ContentPanel } from '../ContentPanel';
import { Box, useMediaQuery } from '@mui/material';
import { ContentSidebar } from '../content-side-bar/ContentSidebar';
import StickyBox from 'react-sticky-box';

export const ContentWithSidebar: React.FC<IContentWithSidebar> = ({
  children,
  sidebarContent,
  afterContent,
  wrapContentInPanel = true,
}): JSX.Element => {
  const hideSidebar = useMediaQuery('(max-width: 600px)');

  return (
    <Box
      sx={{
        display: 'flex',
        columnGap: '10px',
        mt: '10px',
        alignItems: 'flex-start',
      }}
    >
      {/* Content */}
      <Box
        sx={{
          flex: 2,
          minWidth: 0,
        }}
      >
        {wrapContentInPanel && (
          <ContentPanel borderRadius="none">{children}</ContentPanel>
        )}
        {!wrapContentInPanel && children}
        {afterContent && (
          <Box
            sx={{
              mt: '15px',
            }}
          >
            {afterContent}
          </Box>
        )}
      </Box>

      {/* Sidebar */}
      {!hideSidebar && sidebarContent && (
        <StickyBox
          offsetTop={89}
          offsetBottom={10}
          style={{
            flex: 1,
          }}
        >
          <ContentSidebar>{sidebarContent}</ContentSidebar>
        </StickyBox>
      )}
    </Box>
  );
};
